// extracted by mini-css-extract-plugin
export default {"PageFilters":"PageFilters-module__PageFilters__VPOCT","TopBorder":"PageFilters-module__TopBorder__T1FSI"};